<template>
  <div class="row mb-5">
    <div
      :class="[
        form.data.action == 1 && overview && overview.length > 0
          ? 'col-md-8'
          : 'col-md-12',
        disabledForm ? 'div-disabled' : '',
      ]"
    >
      <!-- language selection section -->
      <ul
        v-if="data.language === 'multi'"
        class="nav-main nav-main-horizontal nav-main-hover"
      >
        <li class="nav-main-item ml-lg-auto">
          <a
            class="nav-main-link nav-main-link-submenu"
            data-toggle="submenu"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="nav-main-link-icon fa fa-globe"></i>
            <span class="nav-main-link-name">{{ languages[lang] }}</span>
          </a>
          <ul class="nav-main-submenu nav-main-submenu-right">
            <li class="nav-main-item" v-if="lang !== 'en'">
              <a
                href="javascript:"
                class="nav-main-link active"
                @click="changeLanguage('en')"
              >
                <i class="nav-main-link-icon fa fa-circle text-default"></i>
                <span class="nav-main-link-name">English</span>
              </a>
            </li>
            <li class="nav-main-item" v-else>
              <a
                href="javascript:"
                class="nav-main-link"
                @click="changeLanguage('nl')"
              >
                <i class="nav-main-link-icon fa fa-circle text-secondary"></i>
                <span class="nav-main-link-name">Dutch</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <div v-if="data != null" id="formessagetop">
        <div v-for="(item, keyItem) in fields" :key="keyItem" :index="keyItem">

          <!-- for Motgage section -->
          <PreviewSection
            @modal="setModalContent($event)"
            v-if="
              !Array.isArray(item) &&
              item.widgetCardId === 21 &&
              Object.values(selectedProducts).includes(58)
            "
            :data="item"
          ></PreviewSection>

          <PreviewSection
              @modal="setModalContent($event)"
              v-if="item.action == 'postcode' && !routeparams.makeCalcReady"
              :data="item"
          ></PreviewSection>

          <PreviewSection
              @modal="setModalContent($event)"
              v-if="item.type == 'datewidget' && !routeparams.makeCalcReady"
              :data="item"
          ></PreviewSection>

          <!-- personal details -->
          <PreviewSection
              @modal="setModalContent($event)"
              v-if="item.widgetCardId == '4' && !routeparams.makeCalcReady"
              :data="item"
          ></PreviewSection>
          <!-- personal details -->

          <!-- for personal details widget (also for address!) -->
          <PreviewSection
            @modal="setModalContent($event)"
            v-if="
              !Array.isArray(item) &&
              item.widgetCardId != 8 &&
              item.widgetCardId != 4 &&
              item.widgetCardId != 21 &&
              item.type !== 'familySituation' &&
              item.type !== 'insuranceForLead' &&
              item.type !== 'cityheat' &&
              item.type !== 'datewidget' &&
              item.action !== 'postcode' &&
              item.type !== 'water' &&
              !(item.type == 'products' && !hasProduct)
            "
            :data="item"
          ></PreviewSection>
          <!--  check if mobile is selected and show extra data widget if it is -->
          <PreviewSection
            @modal="setModalContent($event)"
            v-if="
              item.widgetCardId == 8 &&
              Object.values(selectedProducts).includes(8)
            "
            :data="item"
          ></PreviewSection>

          <!-- for family situation widget -->
          <PreviewSection
            @modal="setModalContent($event)"
            v-if="
              item.type === 'familySituation' && !isLead &&
              (Object.values(selectedProducts).includes(1) ||
                Object.values(selectedProducts).includes(2) ||
                Object.values(selectedProducts).includes(3) ||
                Object.values(selectedProducts).includes(7))
            "
            :data="item"
          ></PreviewSection>
          <!-- for InsuranceForLead widget -->

          <PreviewSection
            @modal="setModalContent($event)"
            v-if="
              item.type === 'insuranceForLead' &&
              Object.values(selectedProducts).includes(10)
            "
            :data="item"
          ></PreviewSection>

          <PreviewSection
              @modal="setModalContent($event)"
              v-if="
              item.type === 'cityheat' &&
              Object.values(selectedProducts).includes(7)
            "
              :data="item"
          ></PreviewSection>

          <PreviewSection
              @modal="setModalContent($event)"
              v-if="
              item.type === 'water' &&
              Object.values(selectedProducts).includes(3)
            "
              :data="item"
          ></PreviewSection>

          <div
            class="block"
            :id="item[0].group + 'Block'"
            v-else-if="
              item.length > 0 &&
              ((!item[0].product &&
                !selectedProducts.includes(item[0].product)) ||
                (selectedProducts.includes(item[0].product) &&
                  !(
                    (item[0].type === 'suppliers' ||
                      item[0].type === 'duration' ||
                      item[0].type === 'customizedoffer' ||
                      item[0].type === 'detailedoffer' ||
                      item[0].type === 'html') &&
                    checkElectricGas &&
                    (item[0].product === 1 || item[0].product === 2)
                  )))
            "
          >
            <div
              v-if="
                data.action == 1 &&
                filterOverview(
                  item.filter((x) => x.type !== 'commentWidget')[0].product
                )
              "
              class="block-header"
            >
              <h3 class="block-title">
                {{ item.filter((x) => x.type !== "html")[0].title[lang] }}
              </h3>
              <div class="block-options">
                <button
                  type="button"
                  class="btn-block-option"
                  data-toggle="block-option"
                  data-action="content_toggle"
                >
                  <i class="si si-arrow-up"></i>
                </button>
              </div>
            </div>
            <div v-if="data.action == 1" class="block-content">
              <div v-for="item2 in item" :key="item2.id">
                <!-- for comment widgets -->
                <PreviewSection
                  @modal="setModalContent($event)"
                  :key="item2.id"
                  :data="item2"
                  :index="keyItem"
                  v-if="
                    item2.type === 'commentWidget' &&
                    filterOverview(
                      overview.filter((x) => x.group === item2.fromGroup)[0]
                        ? overview.filter((x) => x.group === item2.fromGroup)[0]
                            .id
                        : -1
                    )
                  "
                ></PreviewSection>
                <!-- for other than comment widgets (detailedoffer, chooseduration ext... ) -->
                <PreviewSection
                  @modal="setModalContent($event)"
                  :key="item2.id"
                  :data="item2"
                  :index="keyItem"
                  v-if="
                    item2.type !== 'commentWidget' &&
                    filterOverview(item2.product)
                  "
                ></PreviewSection>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          (form.data.action == 1 && selectedProducts.length > 0 && !isMobile) ||
          form.data.action == 0
        "
      >

        <!-- LEAD -->
        <template v-if="isLead">

          <button
              class="btn btn-success btn-lg btn-block"
              type="submit"
              id="submit-button"
              v-if="cIsValidSubmit"
          >
            {{
              translate[lang]["sendlead"]
            }}
          </button>

        </template>
        <!-- LEAD -->

        <!-- CONTRACT -->
        <template v-else>

          <template v-if="this.$route.query.reversesubmitbuttons">

            <button
                class="btn btn-outline-success btn-lg btn-block"
                type="submit"
                id="submit-button"
                @click="setLeadforced(0)"
                :disabled="netVolume > 10000"
                :class="netVolume > 10000 ? 'disabled' : ''"
                v-if="cIsValidSubmit && !routeparams.makeCalcReady"
            >
              {{ (this.$route.query.offerfirst == 1 || this.form.data.id == 739) ? translate[lang]["sendoffer"] : translate[lang]["sendform"] }}
            </button>

            <button
                class="btn btn-success btn-lg btn-block"
                type="submit"
                id="submit-button"
                @click="setLeadforced(1)"
                :disabled="netVolume > 10000"
                :class="netVolume > 10000 ? 'disabled' : ''"
                v-if="cIsValidSubmit && this.$route.query.leadfallback && !routeparams.makeCalcReady"
            >
              {{
                translate[lang]["sendlead"]
              }}
            </button>

          </template>

          <template v-else>

            <button
                class="btn btn-outline-success btn-lg btn-block"
                type="submit"
                id="submit-button"
                @click="setLeadforced(1)"
                :disabled="netVolume > 10000"
                :class="netVolume > 10000 ? 'disabled' : ''"
                v-if="cIsValidSubmit && this.$route.query.leadfallback && !routeparams.makeCalcReady"
            >
              {{
                translate[lang]["sendlead"]
              }}
            </button>

            <button
                class="btn btn-success btn-lg btn-block"
                type="submit"
                id="submit-button"
                @click="setLeadforced(0)"
                :disabled="netVolume > 10000"
                :class="netVolume > 10000 ? 'disabled' : ''"
                v-if="cIsValidSubmit && !routeparams.makeCalcReady"
            >
              {{ (this.$route.query.offerfirst == 1 || this.form.data.id == 739) ? translate[lang]["sendoffer"] : translate[lang]["sendform"] }}
            </button>

          </template>

        </template>
        <!-- CONTRACT -->

      </div>
    </div>
    <div
      class="col-md-4"
      v-if="form.data.action == 1 && overview && overview.length > 0"
    >
      <!-- for desktop overview -->
      <div
        v-if="!isMobile"
        class="position-relative"
        :style="'top:' + sidebarTop + 'px'"
        id="sideBarRight"
      >
        <div class="block">
          <div class="block-header block-header-default">
            <h3 class="block-title">{{ translate[lang]["overview"] }}</h3>
          </div>
          <div class="block-content">
            <div class="list-group push" id="overviewScroll">
              <div
                class="list-group-item p-2"
                v-for="item in overview"
                :key="item.id"
                v-if="item.visible"
              >
                <h4 class="font-size-base mb-1">
                  {{
                    item.product[lang] ||
                    translate[lang][item.product] ||
                    translate[lang][item.group] ||
                    item.product
                  }}
                  <i
                    @click="scrollAnimate('#' + item.group + 'Block')"
                    v-if="
                      (formatPrice(
                        item.yearly -
                          (item.discountTotal
                            ? parseFloat(item.discountTotal)
                            : 0)
                      ) != '0,00' &&
                        item.id !== 61 &&
                        item.id !== 7 &&
                        item.id !== 3) ||
                      item.id === 9
                    "
                    class="
                      btn
                      p-0
                      fa fa-eye
                      float-right
                      font-size-sm
                      text-info-light
                    "
                    id="scrollAnimate"
                  ></i>
                </h4>
                <ul
                  v-if="
                    (overview.length === 1 || item.packages.length === 0) &&
                    ((item.group !== 'internet' &&
                      item.supplier &&
                      item.supplier.title) ||
                      (item.group === 'internet' &&
                        combinations[item.group].supplierCheck &&
                        postcodeQuery &&
                        itemsIsShow &&
                        itemsIsShow.filter(
                          (a) => a.id == item.supplier.id
                        )[0] &&
                        itemsIsShow.filter((a) => a.id == item.supplier.id)[0]
                          .isShow))
                  "
                  class="list list-simple-mini font-size-sm mt-0 mb-0"
                >
                  <li
                    v-if="
                      enums[item.group] ? enums[item.group].showSupplier : true
                    "
                  >
                    <span>
                      <span
                        class="font-weight-bold"
                        v-if="item.group === 'hypotheek'"
                        >* {{ item.supplier.title[lang] }}</span
                      >
                      <span
                        class="font-weight-bold"
                        v-if="item.group !== 'hypotheek'"
                        >* {{ item.supplier.title }}</span
                      >
                      <span
                        v-if="item.packages.length === 0 && item.supplier.name"
                      >
                        -
                        {{ parseJSONSupplierName(item.supplier.name, lang) }}
                      </span>
                    </span>
                  </li>
                  <li v-for="item2 in item.packages" :key="item2.id">
                    <span>
                      <span
                        class="font-weight-bold"
                        v-if="
                          enums[item.group]
                            ? enums[item.group].showCategory
                            : true
                        "
                        >* {{ item2.category_name[lang] }}</span
                      >
                      <br
                        v-if="
                          enums[item.group]
                            ? enums[item.group].showCategory
                            : true
                        "
                      />
                      - {{ parseJSONSupplierName(item2.name, lang) }}
                    </span>
                  </li>
                  <li
                    v-if="
                      item.widgets.filter(
                        (x) =>
                          x.status === 1 &&
                          x.supplier_id === item.supplier.id &&
                          x.type !== 'overview'
                      ).length > 0
                    "
                    class="font-weight-bold mb-0"
                  >
                    * {{ translate[lang]["extras"] }}
                  </li>
                  <li
                    v-for="extras in item.widgets.filter(
                      (x) =>
                        x.status === 1 &&
                        x.supplier_id === item.supplier.id &&
                        x.type !== 'overview'
                    )"
                    :key="extras.id"
                  >
                    <span>
                      -
                      {{
                        extras.title
                          ? extras.title[lang]
                          : extras.description[lang]
                      }}
                    </span>
                    <small class="float-right"
                      >€ {{ formatPrice(extras.rate) }}</small
                    >
                  </li>
                  <li
                    v-for="overview in item.widgets.filter(
                      (x) =>
                        x.status === 1 &&
                        x.type === 'overview' &&
                        x.supplier_id === item.supplier.id
                    )"
                    :key="overview.id"
                  >
                    <span>
                      * {{ overview.description[lang] }}
                      <br />
                      €
                      {{ formatPrice(overview.rate) }}
                    </span>
                  </li>
                </ul>
                <ul
                  v-if="!(overview.length === 1 || item.packages.length === 0)"
                  class="list list-simple-mini font-size-sm mt-0 mb-0"
                >
                  <li class="nav-main-item mb-0" v-if="item.supplier">
                    <a
                      class="
                        nav-main-link nav-main-link-submenu
                        bg-transparent
                        p-0
                      "
                      data-toggle="submenu"
                      aria-haspopup="true"
                      aria-expanded="false"
                      href="javascript:"
                    >
                      <span
                        class="nav-main-link-name"
                        v-if="
                          (enums[item.group]
                            ? enums[item.group].showSupplier
                            : true) && item.group !== 'hypotheek'
                        "
                      >
                        {{ item.supplier.title }}
                        <br />
                        <span
                          class="font-weight-light"
                          v-if="item.packages.length === 0"
                          >{{
                            parseJSONSupplierName(item.supplier.name, lang)
                          }}</span
                        >
                      </span>
                      <span
                        class="nav-main-link-name"
                        v-if="
                          (enums[item.group]
                            ? enums[item.group].showSupplier
                            : true) && item.group === 'hypotheek'
                        "
                      >
                        {{
                          item.supplier.title !== undefined
                            ? item.supplier.title[lang]
                            : ""
                        }}
                        <br />
                        <span
                          class="font-weight-light"
                          v-if="item.packages.length === 0"
                          >{{
                            parseJSONSupplierName(item.supplier.name, lang)
                          }}</span
                        >
                      </span>
                    </a>
                    <ul class="nav-main-submenu bg-transparent p-0 pt-0">
                      <li
                        class="mb-1"
                        v-for="item2 in item.packages"
                        :key="item2.id"
                      >
                        <span>
                          <span
                            class="font-weight-bold"
                            v-if="
                              enums[item.group]
                                ? enums[item.group].showCategory
                                : true
                            "
                            >* {{ item2.category_name[lang] }}</span
                          >
                          <br
                            v-if="
                              enums[item.group]
                                ? enums[item.group].showCategory
                                : true
                            "
                          />
                          -
                          {{ parseJSONSupplierName(item2.name, lang) }}
                        </span>
                      </li>
                      <li
                        v-if="
                          item.widgets.filter(
                            (x) =>
                              x.status === 1 &&
                              x.supplier_id === item.supplier.id &&
                              x.type !== 'overview'
                          ).length > 0
                        "
                        class="font-weight-bold mb-0"
                      >
                        * {{ translate[lang]["extras"] }}
                      </li>
                      <li
                        class="mb-1"
                        v-for="extras in item.widgets.filter(
                          (x) =>
                            x.status === 1 &&
                            x.supplier_id === item.supplier.id &&
                            x.type !== 'overview'
                        )"
                        :key="extras.id"
                      >
                        <span>
                          -
                          {{
                            extras.title
                              ? extras.title[lang]
                              : extras.description[lang]
                          }}
                        </span>
                        <small class="float-right"
                          >€ {{ formatPrice(extras.rate) }}</small
                        >
                      </li>
                      <li
                        v-for="overview in item.widgets.filter(
                          (x) =>
                            (x.status === 1) & (x.type === 'overview') &&
                            x.supplier_id === item.supplier.id
                        )"
                        :key="overview.id"
                      >
                        <span>
                          * {{ overview.description[lang] }}
                          <br />
                          €
                          {{ formatPrice(overview.rate) }}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul class="list list-simple-mini font-size-sm mt-0 mb-0">

                  <span
                    class="text-center font-weight-bold"
                    v-if="
                      item.group === 'electricityandgas' ||
                      item.group === 'electricity' ||
                      item.group === 'gas'
                    "
                  >
                    <span
                      v-if="
                        item.group === 'electricityandgas' ||
                        item.group === 'electricity'
                      "
                    >
                      <span v-if="smartMeter == 0">
                        {{ translate[lang]["usage"] }} kWh:
                        {{ consumption.electric.single }} kWh
                        <br />
                      </span>
                      <span
                        v-if="
                          smartMeter == 0 &&
                          calcSolarConsumption() != '0' &&
                          solar.status != '2'
                        "
                      >
                        {{ translate[lang]["expectedreturn"] }} kWh:
                        {{ calcSolarConsumption() }} kWh
                        <br />
                        <!--
                        Netto volume: {{netVolume}} kWh
                        <br />
                        -->
                      </span>
                      <span v-if="smartMeter == 1">
                        {{ translate[lang]["usage"] }} kWh ({{
                          translate[lang]["normal"]
                        }}): {{ consumption.electric.double.high }} kWh
                        <br />
                        {{ translate[lang]["usage"] }} kWh ({{
                          translate[lang]["low"]
                        }}): {{ consumption.electric.double.low }} kWh
                        <br />
                      </span>
                      <span
                        v-if="
                          smartMeter == 1 &&
                          calcSolarConsumption() != '0' &&
                          solar.status != '2'
                        "
                      >
                        {{ translate[lang]["expectedreturn"] }} kWh ({{
                          translate[lang]["normal"]
                        }}):
                        {{
                          solar.kwhKnown == 1
                            ? solar.high == ""
                              ? 0
                              : solar.high
                            : solars.filter(
                                (x) => x.value == solar.number_of_panels
                              ).length > 0 &&
                              solars.filter(
                                (x) => x.value == solar.number_of_panels
                              )[0].high
                            ? solars.filter(
                                (x) => x.value == solar.number_of_panels
                              )[0].high
                            : 0
                        }}
                        kWh
                        <br />
                        {{ translate[lang]["expectedreturn"] }} kWh ({{
                          translate[lang]["low"]
                        }}):
                        {{
                          solar.kwhKnown == 1
                            ? solar.low == ""
                              ? 0
                              : solar.low
                            : solars.filter(
                                (x) => x.value == solar.number_of_panels
                              ).length > 0 &&
                              solars.filter(
                                (x) => x.value == solar.number_of_panels
                              )[0].low
                            ? solars.filter(
                                (x) => x.value == solar.number_of_panels
                              )[0].low
                            : 0
                        }}

                        kWh
                        <br />
                      </span>
                    </span>

                    <span
                      v-if="
                        item.group === 'electricityandgas' ||
                        item.group === 'gas'
                      "
                    >
                      {{ translate[lang]["usage"] }} m3:
                      {{ consumption.gas }} m3
                    </span>
                  </span>

                  <li class="mb-0 text-right">

                    <span
                      v-if="
                        ((item.group == 'electricityandgas' || item.group == 'electricity' ) &&
                          parseFloat(gasTotal) + parseFloat(energyTotal) !==
                            0) ||
                        formatPrice(
                          item.total +
                            (item.packagestotal
                              ? parseFloat(item.packagestotal)
                              : 0)
                        ) != '0,00'
                      "
                      class="text-right mb-0"
                      style="white-space: nowrap"
                    >
                      <span
                        v-if="
                          item.group !== 'electricityandgas' &&
                          item.group !== 'electricity' &&
                          item.group !== 'gas'
                        "
                        class="font-weight-bold"
                        >{{
                          enums[item.group]
                            ? enums[item.group].estimated
                              ? translate[lang]["estimatedpermonth"]
                              : translate[lang]["permonth"]
                            : translate[lang]["permonth"]
                        }}: </span
                      >
                      <span v-if="item.group === 'electricityandgas'">
                        <span class="font-weight-bold">
                          {{ translate[lang]["estimatedpermonth"] }}:
                        </span>
                      </span>
                      <span v-if="item.group === 'electricity'">
                        <span class="font-weight-bold">
                          {{ translate[lang]["estimatedpermonth"] }}:
                        </span>
                      </span>
                      <span v-if="item.group === 'gas'">
                        <span class="font-weight-bold">
                          {{ translate[lang]["estimatedpermonth"] }}:
                        </span>
                      </span>
                      <span style="white-space: nowrap">
                        € {{ formattedPrice(item) }}
                      </span>
                    </span>
                  </li>

                  <li
                    class="mb-0 text-right text-info"
                    v-if="item.discounts && item.discounts.length > 0"
                  >
                    <span
                      class="text-right"
                      v-for="(discount, key) in item.discounts.filter(
                        (a) => a.periodFinished != a.periodStarted
                      )"
                      :key="key"
                    >
                      <span>
                        {{
                          discount.periodStarted
                            ? discount.periodFinished
                              ? finished +
                                " " +
                                (discount.periodFinished -
                                  discount.periodStarted) +
                                " " +
                                translate[lang]["months"]
                              : discount.periodStarted +
                                " - " +
                                discount.periodFinished +
                                " " +
                                translate[lang]["months"]
                            : translate[lang]["first"] +
                              " " +
                              item.discounts[0].period +
                              " " +
                              translate[lang]["months"]
                        }}
                        {{ formatPrice(discount.rate) }}
                      </span>
                      <br />
                    </span>
                  </li>
                  <li class="mb-0 text-right" v-if="item.group !== 'hypotheek'">

                    <span
                      v-if="
                        ((item.group == 'electricityandgas' || item.group == 'electricity') &&
                          parseFloat(gasTotal) + parseFloat(energyTotal) !==
                            0) ||
                        formatPrice(
                          item.yearly -
                            (item.discountTotal
                              ? parseFloat(item.discountTotal)
                              : 0)
                        ) != '0,00'
                      "
                    >
                      <span
                        v-if="
                          item.group == 'electricityandgas' ||
                          item.group == 'electricity' ||
                          item.group == 'gas'
                        "
                        class="font-weight-bold"
                        >{{ translate[lang]["yearlyestimated"] }}:</span
                      >
                      <span v-else class="font-weight-bold"
                        >{{ translate[lang]["yearly"] }}:</span
                      >
                      <span>
                        €
                        {{ formattedYearPriceDT(item) }}
                      </span>
                      <!--
                      <br />

                      <span v-if="item.group === 'electricityandgas'">
                        <span class="font-weight-bold">
                          {{ translate[lang]["monthlyshown"] }} :
                        </span>
                        € {{ formattedYearPriceDT(item, true) }}
                      </span>
                      <span v-if="item.group === 'electricity'">
                        <span class="font-weight-bold">
                          {{ translate[lang]["monthlyshown"] }} :
                        </span>
                        € {{ formattedYearPriceDT(item, true) }}
                      </span>
                      <span v-if="item.group === 'gas'">
                        <span class="font-weight-bold">
                          {{ translate[lang]["monthlyshown"] }} :
                        </span>
                        € {{ formattedYearPriceDT(item, true) }}
                      </span>
                      -->
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="block-header block-header-default">
            <h3 class="block-title">
              {{ translate[lang]["monthlyshown"] }}: <br />€
              {{
                formatPrice(
                    overviewPerMonthTotal
                )
              }}

              <!--
              <small>
                <br />
                {{ translate[lang]["totalyearly"] }}: €

              </small>
              -->
            </h3>
          </div>
          <div class="block-header block-header-default" v-if="showEdit">
            <button
              class="btn btn-outline-success btn-lg btn-block"
              id="edit-button"
              type="button"
              @click="editEvent()"
            >
              {{ translate[lang]["editsubmittedform"] }}
            </button>
          </div>
        </div>
      </div>
      <!-- for mobile overview -->
      <div
        v-if="isMobile"
        id="mobile-overwiev"
        :style="'bottom:0px; position:fixed; background-color:white; z-index: 150; width: 93%;'"
      >
        <div
          class="block-content"
          :style="showBlock ? '' : 'display:none'"
          id="mobilePriceBar"
        >
          <div style="display: flex; height: 20px; align-content: flex-end">
            <i
              class="fas fa-times"
              @click="closeModal"
              style="right: 20px; position: absolute; top: 10px"
            ></i>
          </div>
          <div class="table-responsive">
            <div class="collapse" id="collapseExample">
              <div class="block" style="height: 400px">
                <div class="list-group push" id="overviewScroll">
                  <div
                    class="list-group-item p-2"
                    v-for="item in overview"
                    :key="item.id"
                    v-if="item.visible"
                  >
                    <h4 class="font-size-base mb-1">
                      {{
                        item.product[lang] ||
                        translate[lang][item.product] ||
                        translate[lang][item.group] ||
                        item.product
                      }}
                      <i
                        v-if="
                          (formatPrice(
                            item.yearly -
                              (item.discountTotal
                                ? parseFloat(item.discountTotal)
                                : 0)
                          ) != '0,00' &&
                            item.id !== 61 &&
                            item.id !== 7 &&
                            item.id !== 3) ||
                          item.id === 9
                        "
                        @click="scrollAnimate('#' + item.group + 'Block')"
                        class="
                          btn
                          p-0
                          fa fa-eye
                          float-right
                          font-size-sm
                          text-info-light
                        "
                        id="scrollAnimate"
                      ></i>
                    </h4>
                    <ul
                      v-if="
                        (overview.length === 1 || item.packages.length === 0) &&
                        ((item.group !== 'internet' &&
                          item.supplier &&
                          item.supplier.title) ||
                          (item.group === 'internet' &&
                            combinations[item.group].supplierCheck &&
                            postcodeQuery &&
                            itemsIsShow &&
                            itemsIsShow.filter(
                              (a) => a.id == item.supplier.id
                            )[0] &&
                            itemsIsShow.filter(
                              (a) => a.id == item.supplier.id
                            )[0].isShow))
                      "
                      class="list list-simple-mini font-size-sm mt-0 mb-0"
                    >
                      <li
                        v-if="
                          enums[item.group]
                            ? enums[item.group].showSupplier
                            : true
                        "
                      >
                        <span>
                          <span
                            class="font-weight-bold"
                            v-if="item.group === 'hypotheek'"
                            >* {{ item.supplier.title[lang] }}</span
                          >
                          <span
                            class="font-weight-bold"
                            v-if="item.group !== 'hypotheek'"
                            >* {{ item.supplier.title }}</span
                          >
                          <span v-if="item.packages.length === 0"
                            >-
                            {{
                              parseJSONSupplierName(item.supplier.name, lang)
                            }}</span
                          >
                        </span>
                      </li>
                      <li v-for="item2 in item.packages" :key="item2.id">
                        <span>
                          <span
                            class="font-weight-bold"
                            v-if="
                              enums[item.group]
                                ? enums[item.group].showCategory
                                : true
                            "
                            >* {{ item2.category_name[lang] }}</span
                          >
                          <br
                            v-if="
                              enums[item.group]
                                ? enums[item.group].showCategory
                                : true
                            "
                          />
                          - {{ parseJSONSupplierName(item2.name, lang) }}
                        </span>
                      </li>
                      <li
                        v-if="
                          item.widgets.filter(
                            (x) =>
                              x.status === 1 &&
                              x.supplier_id === item.supplier.id
                          ).length > 0
                        "
                        class="font-weight-bold mb-0"
                      >
                        * {{ translate[lang]["extras"] }}
                      </li>
                      <li
                        v-for="extras in item.widgets.filter(
                          (x) =>
                            x.status === 1 && x.supplier_id === item.supplier.id
                        )"
                        :key="extras.id"
                      >
                        <span>
                          -
                          {{
                            extras.title
                              ? extras.title[lang]
                              : extras.description[lang]
                          }}
                        </span>
                        <small class="float-right"
                          >€ {{ formatPrice(extras.rate) }}</small
                        >
                      </li>
                      <li
                        v-for="overview in item.widgets.filter(
                          (x) =>
                            x.type === 'overview' &&
                            x.supplier_id === item.supplier.id
                        )"
                        :key="overview.id"
                      >
                        <span>
                          * {{ overview.description[lang] }}
                          <br />
                          €
                          {{ formatPrice(overview.rate) }}
                        </span>
                      </li>
                    </ul>
                    <ul
                      v-else
                      class="list list-simple-mini font-size-sm mt-0 mb-0"
                    >
                      <li class="nav-main-item mb-0" v-if="item.supplier">
                        <a
                          class="
                            nav-main-link nav-main-link-submenu
                            bg-transparent
                            p-0
                          "
                          data-toggle="submenu"
                          aria-haspopup="true"
                          aria-expanded="false"
                          href="javascript:"
                        >
                          <span
                            class="nav-main-link-name"
                            v-if="
                              (enums[item.group]
                                ? enums[item.group].showSupplier
                                : true) &&
                              item.group !== 'hypotheek' &&
                              item.group !== 'internet' &&
                              !postcodeQuery
                            "
                          >
                            {{ item.supplier.title }}
                            <br />

                            <span
                              class="font-weight-light"
                              v-if="item.packages.length === 0"
                              >{{
                                parseJSONSupplierName(item.supplier.name, lang)
                              }}</span
                            >
                          </span>

                          <span
                            class="nav-main-link-name"
                            v-if="
                              (enums[item.group]
                                ? enums[item.group].showSupplier
                                : true) && item.group === 'hypotheek'
                            "
                          >
                            {{
                              item.supplier.title
                                ? item.supplier.title[lang]
                                : ""
                            }}
                            <br />
                            <span
                              class="font-weight-light"
                              v-if="item.packages.length === 0"
                              >{{
                                parseJSONSupplierName(item.supplier.name, lang)
                              }}</span
                            >
                          </span>
                        </a>
                        <ul class="nav-main-submenu bg-transparent p-0 pt-0">
                          <li
                            class="mb-1"
                            v-for="item2 in item.packages"
                            :key="item2.id"
                          >
                            <span>
                              <span
                                class="font-weight-bold"
                                v-if="
                                  enums[item.group]
                                    ? enums[item.group].showCategory
                                    : true
                                "
                                >* {{ item2.category_name[lang] }}</span
                              >
                              <br
                                v-if="
                                  enums[item.group]
                                    ? enums[item.group].showCategory
                                    : true
                                "
                              />
                              - {{ parseJSONSupplierName(item2.name, lang) }}
                            </span>
                          </li>
                          <li
                            v-if="
                              item.widgets.filter(
                                (x) =>
                                  x.status === 1 &&
                                  x.supplier_id === item.supplier.id
                              ).length > 0
                            "
                            class="font-weight-bold mb-0"
                          >
                            * {{ translate[lang]["extras"] }}
                          </li>
                          <li
                            class="mb-1"
                            v-for="extras in item.widgets.filter(
                              (x) =>
                                x.status === 1 &&
                                x.supplier_id === item.supplier.id
                            )"
                            :key="extras.id"
                          >
                            <span>
                              -
                              {{
                                extras.title
                                  ? extras.title[lang]
                                  : extras.description[lang]
                              }}
                            </span>
                            <small class="float-right"
                              >€ {{ formatPrice(extras.rate) }}</small
                            >
                          </li>
                          <li
                            v-for="overview in item.widgets.filter(
                              (x) =>
                                x.type === 'overview' &&
                                x.supplier_id === item.supplier.id
                            )"
                            :key="overview.id"
                          >
                            <span>
                              * {{ overview.description[lang] }}
                              <br />
                              €
                              {{ formatPrice(overview.rate) }}
                            </span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul class="list list-simple-mini font-size-sm mt-0 mb-0">
                      <li class="mb-0 text-right">
                        <span
                          v-if="
                            formatPrice(
                              item.total +
                                (item.packagestotal
                                  ? parseFloat(item.packagestotal)
                                  : 0)
                            ) != '0,00'
                          "
                          class="text-right"
                        >
                          <span
                            class="font-weight-bold"
                            v-if="
                              item.group !== 'electricityandgas' ||
                              item.group !== 'electricity' ||
                              item.group !== 'gas'
                            "
                            >{{
                              enums[item.group]
                                ? enums[item.group].estimated
                                  ? translate[lang]["estimatedpermonth"]
                                  : translate[lang]["permonth"]
                                : translate[lang]["permonth"]
                            }}:</span
                          >
                          <span>
                            €
                            {{
                              formatPrice(
                                item.total +
                                  (item.packagestotal
                                    ? parseFloat(item.packagestotal)
                                    : 0)
                              )
                            }}
                          </span>
                        </span>
                      </li>
                      <li
                        class="mb-0 text-right text-info"
                        v-if="item.discounts && item.discounts.length > 0"
                      >
                        <span
                          class="text-right"
                          v-for="(discount, key) in item.discounts.filter(
                            (a) => a.periodFinished != a.periodStarted
                          )"
                          :key="key"
                        >
                          <span>
                            {{
                              discount.periodStarted
                                ? discount.periodFinished
                                  ? finished +
                                    " " +
                                    (discount.periodFinished -
                                      discount.periodStarted) +
                                    " " +
                                    translate[lang]["months"]
                                  : discount.periodStarted +
                                    " - " +
                                    discount.periodFinished +
                                    " " +
                                    translate[lang]["months"]
                                : translate[lang]["first"] +
                                  " " +
                                  item.discounts[0].period +
                                  " " +
                                  translate[lang]["months"]
                            }}
                            {{ formatPrice(discount.rate) }}
                          </span>
                          <br />
                        </span>
                      </li>

                      <li
                        class="mb-0 text-right"
                        v-if="item.group !== 'hypotheek'"
                      >
                        <span
                          v-if="
                            formatPrice(
                              item.yearly -
                                (item.discountTotal
                                  ? parseFloat(item.discountTotal)
                                  : 0)
                            ) != '0,00'
                          "
                        >
                          <span class="font-weight-bold"
                            >{{ translate[lang]["yearly"] }}:</span
                          >
                          <span>
                            €
                            {{
                              formatPrice(
                                item.yearly -
                                  (item.discountTotal
                                    ? parseFloat(item.discountTotal)
                                    : 0)
                              )
                            }}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="block-header block-header-default">
                  <h3 class="block-title">
                    {{ translate[lang]["monthlyshown"] }}: €
                    {{
                      formatPrice(overviewPerMonthTotal + handleMortgagePrice())
                    }}
                    <small>
                      <br />
                      {{ translate[lang]["yearly"] }}: €
                      {{ formatPrice(overviewTotal) }}
                    </small>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          v-if="!showBlock"
          class="btn btn-warning"
          data-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
          :style="'width:' + width"
          @click="overviewClick"
        >
          <h3 class="block-title" style="text-align: left">
            {{ translate[lang]["monthlyshown"] }}: €
            {{ formatPrice(overviewPerMonthTotal + handleMortgagePrice()) }}
            <small>
              {{ translate[lang]["yearly"] }}: €
              {{ formatPrice(overviewTotal) }}
            </small>
          </h3>
        </a>
        <div v-if="selectedProducts.length > 0 && showBlock && !routeparams.makeCalcReady">
          <button
            class="btn btn-success btn-lg btn-block"
            :style="'width:' + width + 'px;'"
            type="submit"
            :disabled="netVolume > 10000"
            :class="netVolume > 10000 ? 'disabled' : ''"
            id="submit-button"
            v-if="cIsValidSubmit"
          >
            {{
              isLead ? translate[lang]["sendlead"] : translate[lang]["sendform"]
            }}
          </button>
        </div>
      </div>
    </div>
    <!-- moreinfo modal -->
    <div
      class="modal fade"
      id="moreinfo"
      role="dialog"
      aria-labelledby=""
      aria-hidden="true"
    >
      <Dialog :content="modalcontent" />
    </div>
    <!-- computed info modal -->
    <div
      class="modal fade"
      id="computedInfo"
      role="dialog"
      aria-labelledby=""
      aria-hidden="true"
    >
      <Dialog :content="modalContentAsComputed" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { SendFormMixin } from "./Mixins/SendFormMixin";
import PreviewSection from "../components/shared/PreviewSection";
import { PrefillWithInitialsMixin } from "./Mixins/PrefillWithInitialsMixin";
import Dialog from "../components/dialog";
import { PrefillMixin } from "./Mixins/PrefillMixin";
import { LanguageMixin } from "./Mixins/LanguageMixin";
import $ from "jquery";
export default {
  name: "ActionForm",
  components: {
    PreviewSection,
    Dialog,
  },
  props: {
    data: {},
    isValidSubmit: {
      type: Boolean,
      default: false,
    },
    initialVal: {
      type: Array,
      default: null,
    },
    isValidSubmittedData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      routeparams: this.$route.query,
      test: 0,
      sidebarTop: "",
      showSideBar: false,
      showBlock: false,
      width: window.innerWidth,
      modalcontent: {
        title: null,
        description: null,
      },
      started: "first",
      finished: "later",
    };
  },
  mixins: [PrefillMixin, LanguageMixin, PrefillWithInitialsMixin, SendFormMixin],
  created() {
    if (!this.isLead) {
      this.setOverview();
    }

  },
  mounted: function () {

    if (this.form.data.language === "multi") {
      if (navigator.language.substring(0, 2) !== this.lang) {
        this.changeLanguage(navigator.language.substring(0, 2));
      }
    }

    var vm = this;
    window.addEventListener("scroll", function () {
      var scrollPos = window.scrollY - 70;
      vm.sidebarTop = window.innerWidth > 768 && scrollPos > 50 ? scrollPos : 0;
    });

    this.initializeForm();

    this.width = $("#formessagetop").css("width");
  },
  computed: {
    ...mapState({
      energyTotal: (state) => state.forms.pricing.energy_total,
      gasTotal: (state) => state.forms.pricing.gas_total,
      total: (state) => state.forms.pricing,
      combinations: (state) => state.forms.combinations,
      defaultDurations: (state) => state.forms.defaultDurations,
      itemsIsShow: (state) => state.forms.itemIsShow,
      modalContentAsComputed: (state) => state.forms.modalContentAsComputed,
      solar: (state) => state.forms.solar,
      solars: (state) => state.forms.solars,
      consumption: (state) => state.forms.consumption,
      meter: (state) => state.forms.meter,
      smartMeter: (state) => state.forms.smartMeter,
      netVolume: (state) => {
        var redelivery = 0;
        if (state.forms.solar.kwhKnown == 1) {
          redelivery = state.forms.solar.single;
        } else {
          redelivery = state.forms.solar.number_of_panels * 240;
        }
        state.forms.consumption.electric.net =
          state.forms.consumption.electric.single - redelivery;
        return state.forms.consumption.electric.net;
      },
      fields: function () {
        let array = [];
        this.data.fields.forEach((element) => {
          if (!$.isEmptyObject(element)) {
            array.push(element);
          }
        });
        return array;
      },
    }),
    cIsValidSubmit() {
      return this.isValidSubmit;
    },
    cIsEdit() {
      return true;
    },
  },
  methods: {
    ...mapMutations({
      setEdit: "forms/SET_EDIT",
      setLeadforced: "forms/SET_LEADFORCED",
    }),
    formattedPrice(item) {

    if(item.id == 4) {

      return this.formatPrice(
          item.total +
          (item.packagestotal
              ? parseFloat(item.packagestotal)
              : 0)
      )

    } else {
      return this.formatPrice(this.filterOverview(item.id).total);
    }



    },
    formattedYearPriceDT(item) {
      return this.formatPrice(this.filterOverview(item.id).yearly);
    },

    handleMortgagePrice() {
      if (this.overview.filter((x) => x.id === 58).length > 0) {
        return parseInt(this.overview.filter((x) => x.id === 58)[0].total);
      } else {
        return 0;
      }
    },
    closeModal() {
      document.getElementById("collapseExample").className = "collapse";
      this.showBlock = false;
    },
    initializeForm() {
      if (this.isValidSubmittedData) {
        this.buildData();
      }
      if (this.initialVal) {
        this.fillFormWithInitials(this.initialVal);
      }
    },
    overviewClick() {
      this.showBlock = !this.showBlock;
    },
    setModalContent(item) {
      this.modalcontent = item;
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    },
    editEvent() {
      this.setEdit(true);
    },
  },
  watch: {
    selectedProducts() {
      if (!this.isLead) {
        this.setOverview();
      }
    },
    overviewTotal() {
      if (this.overviewTotal > 0) {
        this.showSideBar = true;
      } else {
        this.showSideBar = false;
      }
    },
    // postcodeQuery: {
    //   handler: function (val) {
    //     if (
    //       val &&
    //       val.gebruiksdoelen != null &&
    //       val.gebruiksdoelen != undefined &&
    //       this.form.data.customerwidget != undefined
    //     ) {
    //       this.form.data.customertype = val.gebruiksdoelen;
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style scoped>
.div-disabled {
  pointer-events: none;
  opacity: 0.6;
}
@import url(https://fonts.googleapis.com/css?family=Lato:700);
.wdp-ribbon-three {
  display: flex;
  justify-content: left;
  align-items: left;
  background: #fff;
  text-transform: uppercase;
  text-align: left;
  color: rgb(43, 24, 24);
}
</style>
